<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('notFoundPage.title')" :heroSubtitle="$t('notFoundPage.subtitle')" />

    <returnBtn />

  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import returnBtn from "./../components/returnBtn.vue";

export default {
  name: "NotFound",
  components: {
    navMenu,
    hero,
    returnBtn
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
